import { DashboardHeader, WhiteCard, UiButton, UiInput } from "@/components";
import { Head } from "@/components/seo";
import { useEnrolement } from "@/composables/enrolement";
import { Save, Search } from "lucide-react";
import { ChangeEvent, ReactElement, useState, useEffect } from "react";
import { useEnrolementStore } from "@/context/stores/enrolement.store";
import CheckAnimalResult from "@/components/molecules/enrolement/check.animal.result";

interface DashboardEnrolementsIndexProps {}

export default function DashboardEnrolementsIndex({}: DashboardEnrolementsIndexProps) {
  const [matricule, setMatricule] = useState<string | null>(null);
  const { loading, checkAnimal } = useEnrolement();

  const enrol = useEnrolementStore((state) => state.enrol);
  const setEnrol = useEnrolementStore((state) => state.setEnrol);

  // Nettoyer le state enrol quand le composant est démonté
  useEffect(() => {
    return () => {
      setEnrol(null);
    };
  }, [setEnrol]);

  const doSearch = async () => {
    if (!matricule) return;
    await checkAnimal(matricule);
  };

  return (
    <>
      <Head title="Enrolements | Jourgui"></Head>
      <DashboardHeader
        subTitle="Bienvenue sur la page des enrolements"
        showButtons={false}
      />

      <div className="py-4">
        <WhiteCard>
          <div className="py-6">
            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4 mb-4">
              <div className="flex gap-4 w-full items-end">
                <div className="w-full min-w-[200px]">
                  <UiInput
                    label="Matricule"
                    placeholder=""
                    className="w-full"
                    name="matricule"
                    defaultValue={matricule ?? ""}
                    onChange={(v: ChangeEvent<HTMLInputElement>) =>
                      setMatricule(v.target.value)
                    }
                  />
                </div>
                <UiButton
                  startIcon={<Search />}
                  loading={loading}
                  onClick={doSearch}
                >
                  Rechercher
                </UiButton>
              </div>
            </div>
            <CheckAnimalResult
              matricule={matricule ?? ""}
              loading={loading}
              enrol={enrol}
            />
          </div>
        </WhiteCard>
      </div>
    </>
  );
}
